module.exports = __webpack_public_path__ + "img/Check_White.f1cbcbf8.svg";